import RadioGroup from '../components/RadioGroup'
import Toggle from '../components/Toggle'
import ButtonGroup from '../components/ButtonGroup'
import PriceBox from '../components/PriceBox'
import store from '../store'
import { mapGetters } from 'vuex'
import NumberToggle from '../components/NumberToggle'
import CoverDetails from '../components/Quote/CoverDetails'
import WhyChooseUs from '../components/WhyChooseUs'
import EmailInput from '../components/EmailInput'
import PhoneInput from '../components/PhoneInput'
import commonMethods from '../common/methods'
import Questions from '../components/Quote/Questions'
import CaptureForm from '../components/Quote/CaptureForm'

import VueRouter from 'vue-router'
import { routes } from './quote-routes'
import { BUSINESS_ROADSIDE_FORM, COVER_TYPE, PERSONAL_ROADSIDE_FORM } from '../constants'

window.Vue.use(VueRouter)

const router = new VueRouter({
	base: window.routerBase,
	mode: 'history',
	routes,
})

const app = new window.Vue({
    store,
    router,
    el: '#join',
    components: {
        RadioGroup,
        Toggle,
        NumberToggle,
        ButtonGroup,
        PriceBox,
        CoverDetails,
        WhyChooseUs,
        EmailInput,
        PhoneInput,
        Questions,
        CaptureForm
    },
    computed: {
        ...mapGetters({
            quote: 'quote',
            vehicles: 'vehicles',
            customer: 'customer',
            policy_start_date: 'policy_start_date',
            available_services: 'available_services',
            hidden_excess: 'hidden_excess',
            business_account: 'business_account',
            business_addresses: 'business_addresses',
        })
    },
    data() {
        return {
            reviewDisableContinue: false, // false
            couponEnabled: true,
            newQuote: window.newQuote,
			package: window.package,
            COVER_TYPE: COVER_TYPE,
            loading: false,
            loadingPrice: false,
            form: {
                ...PERSONAL_ROADSIDE_FORM,
                startDate: {
                    value: null,
                    datepickerState: {}
                },
                vehicles: [],
                people: [],
                emailAddress: null,
                phone: {
                    value: null,
                },
                referrerId: null,
                buyapowaVoucherCode: null,
                title: {
                    value: null,
                },

                name: {
                    value: null,
                },

                surname: {
                    value: null,
                },

                dateOfBirth: {
                    day: {
                        value: '',
                        options: [],
                    },

                    month: {
                        value: '',
                        options: [],
                    },
                    year: {
                        value: '',
                        options: [],
                    },
                },
            },
            steps: [
                {
                    name: "cover_type"
                },
                {
                    name: 'vehicle',
                },
                {
                    name: 'home',
                },
                {
                    name: 'nationwide',
                },
            ],
            currentStep: 0,
            review: window.review,
            price: null,
            showPrice: window.review,
            customPrice: false,
            nextRouteUrl: window.nextRouteUrl,
            priceBoxCta: 'Continue',
            pay: false,
            showFreeMotOption: false,
            getPriceStep: window.getPriceStep,
            callUsStep: false,
            quoteIdSet: null,
            returningQuote: window.returningQuote,
            returningQuoteId: window.returningQuoteId,
            coupon: {
                disabled:null,
                value: null,
                success: null,
                message: null,
                hide: false,
                discountType: null,
                discount: 0, //coupon value
            },
            utmData: window.utmData,
            landingPage: window.landingPage,
            emailRfcCheckFailed: '',
            preDiscountPrice: 0,
            partsAndLabourPrice: 0,
            captureCtaSpinner: false,
            servicePricing: [],
            returningQuoteLoading: false,
        }
    },
    methods: {
        ...commonMethods,
        prepareVuexQuote() {
            let data = {
                home: this.form.home.value,
                nationwide: this.form.nationwide.value,
                local: this.form.local.value ? 1 : 0,
                roadside: this.form.roadside.value ? 1 : 0,
                personal: this.form.personal.value,
                onward: this.form.onward.value,
                misfuel: this.form.misfuel.value,
                excess: this.form.excess.value ? 1 : 0,
                accident: this.form.accident.value ? 1 : 0,
                unlimited: this.form.unlimited.value ? 1 : 0,
                european: this.form.european.value ? 1 : 0,
                accident_plus: this.form.accident_plus.value ? 1 : 0,
                parts_labour: this.form.parts_labour.value ? 1 : 0,
                parts_labour_no_vehicles: this.form.parts_labour.value ? this.form.vehicles.filter(vitem => vitem.parts_exclude == "").length : 0,
                caravan_trailer: this.form.caravan_trailer.value ? 1 : 0,
                key: this.form.key.value ? 1 : 0,
                battery: this.form.battery.value,
                tyre: 0, //this.form.tyre.value,
                coupon: this.quote.coupon,
                package: this.quote.package,
                id: null,
                referrer_id: this.form.referrerId,
                buyapowa_voucher_code: this.form.buyapowaVoucherCode,
                no_people: this.form.people_form?.value ? this.form.people_form?.value : null,
                cover_type: this.form.cover_type?.value ? this.form.cover_type?.value : null,
            }

            if(data.package){
				data.package_id = data.package.packages_id
            }
            else {
                data.package_id =  window.package.packages_id
            }

            if (this.quoteIdSet) {
                data.id = this.quoteIdSet
            }

            return data
        },
        prepareVuexVehicles (){

            let vehiclesToAdd = []
            let setPrimary = 1;
            for (let vehiclesKey in this.form.vehicles) {
                let vehicle = this.form.vehicles[vehiclesKey]
                let vehicleToAdd = {}
                if (vehicle.manual) {
                    vehicleToAdd.make = vehicle.make.value
                    vehicleToAdd.model = vehicle.model.value
                    vehicleToAdd.year = vehicle.year.value
                } else {
                    vehicleToAdd = vehicle.result
                }
                vehicleToAdd.vrm = vehicle.vrm.value
                vehicleToAdd.primary = setPrimary
                vehicleToAdd.parts_exclude = vehicle.parts_exclude
                vehiclesToAdd.push(vehicleToAdd)

                setPrimary = 0;
            }

            return vehiclesToAdd

        },
        async updateVuexQuote() {
            await this.$store.commit('SET_QUOTE', this.prepareVuexQuote())
        },
        async updateVuexVehicles() {
            await this.$store.commit('SET_VEHICLES', this.prepareVuexVehicles())
        },
        async submitPriceStep(event) {

            this.captureCtaSpinner = true
            await this.updateVuexQuote()
            await this.$store.commit('SET_START_DATE', this.form.startDate.value)
            await this.$store.commit('RESET_VEHICLES')
            
            let vehiclesToAdd = []
            let setPrimary = 1;
            for (let vehiclesKey in this.form.vehicles) {
                let vehicle = this.form.vehicles[vehiclesKey]
                let vehicleToAdd = {}
                if (vehicle.manual) {
                    vehicleToAdd.make = vehicle.make.value
                    vehicleToAdd.model = vehicle.model.value
                    vehicleToAdd.year = vehicle.year.value
                } else {
                    vehicleToAdd = vehicle.result || {}
                }
                vehicleToAdd.vrm = vehicle?.vrm?.value ?? null
                vehicleToAdd.primary = setPrimary
                vehicleToAdd.parts_exclude = ""
                vehiclesToAdd.push(vehicleToAdd)

                setPrimary = 0;
            }

            await this.$store.commit('SET_VEHICLES', vehiclesToAdd)

            let customerData = {
                email: this.form.emailAddress,
                phone: this.form.phone.value,
                firstname: this.form?.name?.value ? this.form?.name?.value : window.buyapowaFriendFirstName ?? null,
                surname: this.form?.name?.value ? this.form?.surname?.value : window.buyapowaFriendLastName ?? null,
                dateOfBirth: {
                    day: {
                        value: this.form?.dateOfBirth?.day?.value ?? null,
                        options: []
                    },
                    month: {
                        value: this.form?.dateOfBirth?.month?.value ?? null,
                        options: []
                    },
                    year: {
                        value: this.form?.dateOfBirth?.year?.value ?? null,
                        options: []
                    }
                }
            }


            await this.$store.commit('SET_CUSTOMER', customerData)


            let createQuoteData = this.prepareQuoteRequestData()

            if(window.splitId && window.splitId > 0){
                createQuoteData.splitTestId = window.splitId
            }

            let result;
            if (this.quote.id) {
                result = await this.apiUpdatePartialQuote(createQuoteData)
                this.quoteIdSet = this.quote.id
            } else {
                result = await this.apiCreateQuote(createQuoteData)

                if (result === null || result.status !== 'success') {
                    //todo: manage error
                    if(result.status === 'error' && result.message === 'Customer email is invalid'){
                        const suggestion = this.getEmailSuggestion(this.form.emailAddress);
                        if (suggestion) {
                            this.emailRfcCheckFailed = `Email address is not valid. Did you mean ${suggestion}?`;
                        } else {
                            this.emailRfcCheckFailed = 'Email address is not valid.'
                        }
                    }
                    this.captureCtaSpinner = false
                    return
                }

                if (result.quote_id) {
                    await this.$store.commit('SET_QUOTE_ID', result.quote_id)
                    this.quoteIdSet = result.quote_id

                    await this.logUtmData()
                }
            }


            if (window.coupon) {
                const couponData = {
                    value: window.coupon.coupon,
                    discountType: window.coupon.discount_type,
                    discount: window.coupon.discount
                }

                this.setAppliedCoupon(couponData)
                await this.applyCoupon()

            } else {
				this.setPriceFromApiResult(result)
            }

            this.showPrice = true

            if (this.$route.name !== 'Review') {
                await this.$router.push({ name: 'Review' });
              }              

            this.sendBingPageview('/breakdown-cover/your-quote/review')
            this.sendGaPageview('/breakdown-cover/your-quote/review')
            if(typeof window.isFbClickUser !== 'undefined' && window.isFbClickUser === true){
                this.sendFacebookLead()
            }
            this.sendGoogleAdsConversion('AW-746028375/Ox5-CIie-ZEDENf63eMC')

            if (window.coupon) {

                this.$nextTick(() => {
                    this.$refs.pricebox.showCouponField()
                })
            }
            this.captureCtaSpinner = false
            return false

        },
        async changeNumberOfEntities(entityType, newNumber) {
            const entities = this.form[entityType];
            const currentNumber = entities.length;

            if (currentNumber < newNumber) {
                const difference = newNumber - currentNumber;
                for (let i = 0; i < difference; i++) {
                    let emptyObj = entityType === 'people' ? this.getEmptyPeopleInfo() : this.getEmptyVehicle()
                    entities.push(emptyObj);
                }
            } else if (currentNumber > newNumber) {
                this.form[entityType] = entities.slice(0, newNumber);
            }
            if(entityType === 'people') {
                await this.$store.commit('INIT_PEOPLE_ARR', this.form.people)
            }
        },
        async onCompleteQuestions() {

            // remove if statement after A/B testing for hidePersonalPackageFlow
            // if(window.hidePersonalPackageFlow) {
            //     this.form.cover_type.value = 'vehicleCover'
            // }

            if (this.form?.cover_type?.value === 'personalCover') {
                this.changeNumberOfEntities('people', this.form.people_form.value - 1 );
            } else {
                this.changeNumberOfEntities('vehicles', this.form.vehicle.value);
            }
            this.initStartDate()
            await this.$router.push({name: 'CaptureForm'})
            this.sendBingPageview()
            this.sendGaPageview()
        },
        async triggerCallUs() {
            await this.$router.push({name: 'CallUs'})
            this.sendBingPageview()
            this.sendGaPageview()
        },
        async updateQuotePrice() {

            this.loadingPrice = true
            if (this.form.vehicle.value > this.form.vehicle.max) {
                this.customPrice = true
                this.loadingPrice = false
                return
            }
            this.customPrice = false

            await this.updateVuexQuote()

            this.form?.cover_type?.value === COVER_TYPE.personalCover ?? await this.updateVuexVehicles()
            await this.calculateQuote()
        },
        async submit() {
            await this.updateVuexQuote()
            this.form?.cover_type?.value === COVER_TYPE.personalCover ?? await this.updateVuexVehicles()

            let data = this.prepareQuoteRequestData()
            await this.apiUpdatePartialQuote(data)
            document.getElementById('join__quote').submit()
        },
        async restart(destination) {
            this.currentStep = 0
            await this.$store.commit('SET_QUOTE', null)
            window.location.href = destination
        },
        updateFormData(quoteValues) {
            this.form.home.value = quoteValues.home
            this.form.nationwide.value = quoteValues.nationwide
            this.form.local.value = quoteValues.local
            this.form.roadside.value = quoteValues.roadside
            this.form.personal.value = quoteValues.personal
            this.form.onward.value = quoteValues.onward
            this.form.misfuel.value = quoteValues.misfuel
            this.form.battery.value = quoteValues.battery
            this.form.excess.value = quoteValues.excess
            this.form.accident.value = quoteValues.accident
            this.form.tyre.value = 0;
            this.form.parts_labour.value = quoteValues.parts_labour

            if(quoteValues.cover_type) {
                this.form.cover_type.value = quoteValues.cover_type 
            } 

            // Check if cover_type is set to personal cover
            if (this.form?.cover_type?.value === 'personalCover' && quoteValues?.no_people) {
                this.form.no_people = quoteValues.no_people;
            } else {
                this.form.vehicle.value = quoteValues.no_vehicles
            }
                
        },
        async applyFreeMotAddons() {
            this.form.nationwide.value = 1
            this.form.home.value = 1
            this.form.misfuel.value = 1
            this.form.excess.value = 0
            await this.updateVuexQuote()
            await this.calculateQuote()
        },

        async applyFreeAddons() {
            this.form.misfuel.value = 0
            this.form.onward.value = 0
            this.form.excess.value = 0
            await this.updateVuexQuote()
            await this.calculateQuote()
        },


        async initFromExistingQuote() {
            // Default Values in case API fails.
            let quoteDefault = this.getDefaultQuoteObject()
            // Reset Any Previous Quote.
            await this.$store.commit('RESET_ALL')
            await this.$store.commit('SET_START_DATE', this.form.startDate.value)

            // Get the Returning Quote Data.
            const resultGetQuote = await this.apiGetQuote(this.returningQuoteId)
            if (resultGetQuote.status == 'success') {

                // Set the Quote ID
                this.quoteIdSet = this.returningQuoteId

                // Set the Variables
                quoteDefault = {
                    home: resultGetQuote.quote.home,
                    nationwide: resultGetQuote.quote.nationwide,
                    local: resultGetQuote.quote.local,
                    roadside: resultGetQuote.quote.roadside,
                    personal: resultGetQuote.quote.personal,
                    onward: resultGetQuote.quote.onward,
                    misfuel: resultGetQuote.quote.misfuel,
                    excess: resultGetQuote.quote.excess,
                    accident: resultGetQuote.quote.accident,
                    unlimited: resultGetQuote.quote.unlimited,
                    european: resultGetQuote.quote.european,
                    accident_plus: resultGetQuote.quote.accident_plus,
                    parts_labour: resultGetQuote.quote.parts_labour,
                    parts_labour_no_vehicles: resultGetQuote.quote.parts_labour_no_vehicles,
                    caravan_trailer: resultGetQuote.quote.caravan_trailer,
                    key: resultGetQuote.quote.key,
                    battery: resultGetQuote.quote.battery,
                    tyre: 0, //resultGetQuote.quote.tyre,
                    cover_type: resultGetQuote.quote.cover_type,
                    id: this.returningQuoteId
                };

                if(resultGetQuote.quote.package){
                    quoteDefault.package = resultGetQuote.quote.package
                    quoteDefault.package_id = resultGetQuote.quote.package.packages_id
                    if(this.isPersonalBespoke(resultGetQuote.quote.package.slug)) {
                        quoteDefault.cover_type = COVER_TYPE.personalCover
                    }
                }

                let peopleToAdd = []
                let vehiclesToAdd = []
                if(quoteDefault?.cover_type === COVER_TYPE.personalCover) {
                    let personToAdd = this.getEmptyPeopleInfo()

                    for (let i = 1; i < resultGetQuote.quote.no_people; i++) {
                        peopleToAdd.push(personToAdd)
                    }
                } else {
                    for (let vehiclesKey in resultGetQuote.quote.vehicles) {
                        let vehicle = resultGetQuote.quote.vehicles[vehiclesKey]
                        let vehicleToAdd = vehicle
                        vehicleToAdd.vrm = vehicle.vrm
                        vehicleToAdd.primary = vehicle.primary
                        vehiclesToAdd.push(vehicleToAdd)
                    }
    
                }   
    
                await this.$store.commit('SET_VEHICLES', vehiclesToAdd)
                await this.$store.commit('SET_PEOPLE', peopleToAdd)

                if(quoteDefault?.cover_type !== COVER_TYPE.personalCover || !quoteDefault?.cover_type) {
                    await this.retrieveVehicles()
                } else {
                    await this.retrievePeople()
                }
                //await this.retrievePeople()

                if(resultGetQuote.quote.customer && resultGetQuote.quote.customer.email){
                    let customerData = {
                        email: resultGetQuote.quote.customer.email
                    }
                    await this.$store.commit('SET_CUSTOMER', customerData)
                }

                // Set the Quote in the Session (Local Storage)
                await this.$store.commit('SET_QUOTE', quoteDefault)

                if (window.coupon) {
                    const couponData = {
                        value: window.coupon.coupon,
                        discountType: window.coupon.discount_type,
                        discount: window.coupon.discount
                    }

                    this.setAppliedCoupon(couponData)
                    await this.applyCoupon()
                } else {
                    await this.initCoupon()
                }

                // Calculate Price and Display.
                await this.calculateQuote()
                this.updateFormData(quoteDefault)
                this.reviewDisableContinue = false

            }
            else {
                console.log("Error Retrieving Quote")
            }
        },

        async applyCoupon() {

            this.coupon.value = this.coupon.value.replace(/\W/g, '')

            const result = await this.apiApplyCoupon(this.coupon.value)
            if (!result) {
                this.coupon.disabled = false
                this.coupon.success = false
                this.coupon.discountType = null
                this.coupon.discount = 0
                this.coupon.message = "Sorry, this code is not valid."
                return;
            }

            this.coupon.disabled = true
            this.coupon.success = true
            this.coupon.message = "Discount code " + this.coupon.value.toUpperCase() + " applied!"
            this.coupon.discountType = result.discount_type
            this.coupon.discount = result.discount
            this.setPriceFromApiResult(result)

            const couponData = {
                value: this.coupon.value,
                discountType: result.discount_type,
                discount: result.discount
            }

            await this.$store.commit('SET_COUPON', couponData)

        },
        async removeCoupon() {
			this.coupon.disabled = false

			this.coupon.value = this.coupon.value.replace(/\W/g, '')

			const result = await this.apiRemoveCoupon()

			if (!result) {
				this.coupon.success = false
				this.coupon.message =
					'Failed to Remove Code Please Call Us For Assistance.'
				return
			}

			this.coupon.success = false
			this.coupon.message =
				'Discount code ' + this.coupon.value.toUpperCase() + ' removed!'
            this.setPriceFromApiResult(result)
            this.coupon.value = null
            this.coupon.discountType = result.discount_type
            this.coupon.discount = result.discount

			await this.$store.commit('SET_COUPON', null)
		},
        checkCouponSuccess() {
            if (!this.couponSuccess) {
                return
            }
            this.coupon.disabled = true
            this.coupon.success = true
            this.coupon.message = "Discount code " + this.coupon.value.toUpperCase() + " applied!"

            if (this.$refs.pricebox) {
                this.$refs.pricebox.showCouponField()
            }
        },
        applyPrefilledAddons(quoteDefault) {
            window.prefilledAddons.forEach(item => {
                quoteDefault[item] = 1
            })
            const hasLocalRecovery = window.prefilledAddons.find(item => {
                return item === 'local'
            })
            if (hasLocalRecovery) {
                quoteDefault.local = 1;
                this.form.local.value = 1
                this.form.local.disabled = true
            }
            return quoteDefault
        },

        applyFreePromo(quoteDefault){

            const freeOnward = this.coupon?.value === 'FREEONWARD'

            const freeMisfuel = this.coupon?.value === 'FREEMISFUEL'

            if(freeMisfuel) {
                quoteDefault.misfuel = 1;
                this.form.misfuel.value = 1;
                this.form.disabled = true;
            }

            if(freeOnward) {
                quoteDefault.onward = 1;
                this.form.onward.value = 1;
                this.form.disabled = true;
            }

            return quoteDefault

        },
        async initCoupon() {
            if (window.coupon) {
                const couponData = {
                    value: window.coupon.coupon,
                    discountType: window.coupon.discount_type,
                    discount: window.coupon.discount
                }
                await this.$store.commit('SET_COUPON', couponData)
                this.couponEnabled = true
                this.coupon = couponData;
                return
            }
            await this.$store.commit('SET_COUPON', null)
        },
        async initNewQuote() {
            let quoteDefault

            if (window.prefilledAddons) {
                quoteDefault = this.getDefaultQuoteObject()
                quoteDefault = this.applyPrefilledAddons(quoteDefault)
            }

            // New/Fresh Quote - Question Flow.
            // Reset ALL Values.
            quoteDefault = {
                home: null,
                nationwide: null,
                local: 1,
                roadside: 1,
                personal: null,
                onward: null,
                misfuel: null,
                excess: 0,
                accident: 1,
                unlimited: 1,
                european: 0,
                accident_plus: 0,
                parts_labour: 0,
                caravan_trailer: 0,
                key: 0,
                battery: null,
                tyre: null,
                no_vehicles: 0,
                no_people: 0,
                id: null,
            };

            if(window.package){
                quoteDefault.package = window.package
            }

            if (this.hidden_excess) {
                quoteDefault.excess = 0
                this.form.excess.value = 0
            }

            if (window.coupon) {
                quoteDefault.coupon = {
                    value: window.coupon.coupon,
                    discountType: window.coupon.discount_type,
                    discount: window.coupon.discount
                }
            }

            await this.initCoupon()

            if (window.discountCode) {
                quoteDefault = this.applyFreePromo(quoteDefault)
            }

            await this.$store.commit('RESET_ALL')
            await this.$store.commit('SET_QUOTE', quoteDefault)

            // Hide Excess Field.
            this.$store.commit('SET_HIDDEN_EXCESS', true)
            this.initVehicles();

        },
        async calculateQuote() {
            this.loadingPrice = true

            // Add the Vehicles to the Quote Data as NOW needed for Parts and Labour.
            if(this.quote.parts_labour == 1){
                this.quote.vehicles = this.prepareVuexVehicles()
            }

            this.quote.tyre = 0
            
            const result = await this.apiGetCalculation(this.quote.id, this.quote)
            if(result && result.service_pricing) {
                this.servicePricing = result.service_pricing
            }
            this.loadingPrice = false
            if (!result) {
                return
            }
            this.setPriceFromApiResult(result)
        },
        getFormVehicleFromStore(storeVehicle) {
            return {
                make: {value: storeVehicle.make},
                model: {value: storeVehicle.model},
                manual: false,
                vrm: {value: storeVehicle.vrm},
                year: {value: storeVehicle.year},
                lookedUp: false,
                parts_exclude: storeVehicle.parts_exclude
            }
        },
        getFormPeopleFromStore(storePeople) {
            return {
                name: {value: storePeople.name},
                surname: {value: storePeople.surname},
                dob: {value: storePeople.dob},
                phone: {value: storePeople.phone},
            }
        },
        async retrieveVehicles() {
            if (!this.form.vehicles.length) {
                if (this.vehicles.length) {
                    this.vehicles.forEach(item => {
                        this.form.vehicles.push(this.getFormVehicleFromStore(item))
                    })
                } else {
                    this.addEmptyVehicle()
                }
            }
            for (let i = 0; i < this.form.vehicles.length; i++) {
                let item = this.form.vehicles[i]
                if (item.result) {
                    return
                }
                if (!item.vrm.value) {
                    return
                }
                await this.lookupVrm(item, i)
            }
        },
        async retrievePeople() {

            const peopleCount = this.$store.getters.quote.no_people;

            if(peopleCount) {
                this.form.people_form.value = peopleCount
            }

            if(peopleCount > 1) {
                const peopleArray = this.$store.getters.people;
                this.form.people = peopleArray.map(item => this.getFormPeopleFromStore(item))
            }
        },
        setPackage(packageObject){
            this.package = packageObject
            this.form.vehicle.max = packageObject.max_vehicles

        },
        async initReturningQuote() {
            if(this.quote?.cover_type !== COVER_TYPE.personalCover || !this.quote?.cover_type) {
                await this.retrieveVehicles()
            } else {
                await this.retrievePeople()
            }
            this.initStartDate()

            if(this.quote.package){
                this.setPackage(this.quote.package)
            }
            // Refreshed Page Quote -  Clicked Back etc.
            // Uses the Quote Saved in the local storage session.
            if (this.quote.coupon) {
                this.setAppliedCoupon(this.quote.coupon)
                if (this.$refs.pricebox) {
                    this.$refs.pricebox.showCouponField()
                }
            }
            if (this.quote.id) {
                this.quoteIdSet = this.quote.id
                await this.calculateQuote()
            }

            // init quote to store values
            this.updateFormData(this.quote)

            // Hide excess
            this.$store.commit('SET_HIDDEN_EXCESS', true)
        },
        isCurrentRoute(name) {
            return this.$route.name === name
        },
        loadTrustpilot() {
            this.loadTrustpilotWidget(this.$refs.trustboxDesktop)
            this.loadTrustpilotWidget(this.$refs.trustboxMobile)
        },
        getBusinessForm() {
            return {
                ...BUSINESS_ROADSIDE_FORM,
                startDate: {
                    value: null,
                    datepickerState: {}
                },
                vehicles: [],
                emailAddress: null,
                phone: {
                    value: null,
                },
            }
        },
        initBusinessFlow() {
            this.form = this.getBusinessForm()
            this.steps = [
                {
                    name: 'vehicle',
                },
                {
                    name: 'home',
                },
                {
                    name: 'nationwide',
                },
            ]
        },
        initForm() {
            if (this.isBusinessFlow()) {
                this.initBusinessFlow()
            // remove else if statement after A/B testing for hidePersonalPackageFlow
            } else if (window.hidePersonalPackageFlow) {
                this.steps = [
                    {
                        name: 'vehicle',
                    },
                    {
                        name: 'home',
                    },
                    {
                        name: 'nationwide',
                    },
                ]
            }
        },
        async logUtmData()
        {
            if(typeof this.landingPage === 'undefined'){
                return
            }
            if(typeof this.utmData === 'undefined'){
                this.utmData = []
            }
            await this.apiLogQuoteUserAcquisition({
                quote_id: this.quote.id,
                landing_page: this.landingPage,
                utm_data: this.utmData
            })
        },
        sendQuoteHotjarIdentifier(){
            if(this.quote && this.quote.id){
                this.sendHotjarIdentifier(this.quote.id,this.quote)
            }
        },
        async changeTerm(term){

            if(this.quote?.package?.subscription_term == term || (term == "year" && !this.quote.package.subscription_term)){
                return
            }
            this.loadingPrice = true
            let quoteData = this.prepareVuexQuote()
            const newPackage = await this.apiTogglePackageTerm(term, this.quote.package_id)
            quoteData.package = newPackage
            await this.$store.commit('SET_QUOTE', quoteData)
            await this.updateVuexQuote()
            await this.calculateQuote()
        },
        setBuyapowaData() {
            if (window.buyapowaFriendEmail) {
                this.form.emailAddress = window.buyapowaFriendEmail;
                this.form.phone.value = window.buyapowaFriendPhone;
                this.form.referrerId = window.buyapowaReferrer;
                this.form.buyapowaVoucherCode = window.buyapowaVoucherCode;
            }
        },
        updateReviewDisableContinue(allSelectedAddOn) {

            //this.reviewDisableContinue = !allSelectedAddOn;

            // Split Test Showing Green Button and Not need to CLick.
            if(window.testDisabledButton){
                this.reviewDisableContinue = false;
            }
            else {
                this.reviewDisableContinue = !allSelectedAddOn;
            }

            if(window.newSplitVersion && !this.reviewDisableContinue){
                if (this.returningQuote && this.returningQuoteId) {
                    document.querySelector('#footer-content').classList.add('mt-6');
                    document.querySelector('#footer-content').classList.add('md:mt-0');
                }

                document.querySelector('#footer-content').classList.add('pt-6');
                document.querySelector('#footer-content').classList.add('sm:pt-6');
            }

        },
        isPersonalBespoke(slug) {
            return slug === "personal-bespoke-monthly" || slug === "personal-bespoke";
        },
        emailFieldChange(val) {
            this.emailRfcCheckFailed = ''
        },
        getEmailSuggestion(email) {
            const parts = email.split('@');
            
            // Ensure the email has exactly one "@" symbol
            if (parts.length !== 2) return null;

            const [local, domain] = parts;

            // Clean up the domain to handle case-insensitivity
            const emailSuggestions = {
                // Gmail
                'gamil.com': 'gmail.com',
                'gnail.com': 'gmail.com',
                'gmail.co.uk': 'gmail.com',
                'gmaill.com': 'gmail.com',
                'gmail.con': 'gmail.com',
                'gmial.com': 'gmail.com',
                'gmail.om': 'gmail.com',
                'gemail.com': 'gmail.com',
                'gmaik.com': 'gmail.com',
                'gmaul.com': 'gmail.com',
                'gmai.com': 'gmail.com',
                'gmail.co': 'gmail.com',
                'fmail.com': 'gmail.com',
                'fooglemail.com': 'googlemail.com',

                // Yahoo
                'yahoo.com.uk': 'yahoo.co.uk',
                'yahoo.uk': 'yahoo.co.uk',
                'yaho.co.uk': 'yahoo.co.uk',
                'yaho.com': 'yahoo.com',
                'yahho.com': 'yahoo.com',
                'yaoo.com': 'yahoo.com',
                'yaho.net': 'yahoo.com',

                // Hotmail
                'hotmial.com': 'hotmail.com',
                'hotmil.com': 'hotmail.com',
                'hotnail.com': 'hotmail.com',
                'homtail.com': 'hotmail.com',
                'hotnail.co.uk': 'hotmail.com',
                'hotmai.co.uk': 'hotmail.com',
                'hotmsil.co.uk': 'hotmail.com',
                'hitmail.co.uk': 'hotmail.com',
                'hitmail.com': 'hotmail.com',
                'hotmaik.co.uk': 'hotmail.com',

                // Outlook
                'outlok.com': 'outlook.com',
                'outllok.com': 'outlook.com',
                'oulook.com': 'outlook.com',
                'outlookl.com': 'outlook.com',
                'outloo.com': 'outlook.com',

                // iCloud
                'iclod.com': 'icloud.com',
                'icoud.com': 'icloud.com',

                // Live
                'liv.com': 'live.com',
                'lve.com': 'live.com',

                // AOL
                'aol.co.uk': 'aol.com',
                'ail.com': 'aol.com',
                'aoll.com': 'aol.com'
            };

            // Convert domain to lowercase for case-insensitive matching
            const suggestion = emailSuggestions[domain.toLowerCase()];

            // If we have a suggestion, return it
            if (suggestion) {
                return `${local}@${suggestion}`;
            }

            return null;
        }
    
    },
    created() {
        this.initForm()
    },
    async mounted() {

        await this.initAvailableServices()

        this.initDefaultServices()

        this.setBuyapowaData();
        if (this.returningQuote && this.returningQuoteId) {

            // Get a quote from an ID
            // Resets the Session with the Quote, Policy Start Date and Vehicles.
            this.returningQuoteLoading = true
            await this.initFromExistingQuote()
            this.returningQuoteLoading = false

            await this.$router.push({name: 'Review'})
            this.sendBingPageview()
            this.sendGaPageview()
            this.sendHotjarIdentifier(this.returningQuoteId,this.quote)
            return;
        }


        // !this.isCurrentRoute(('CaptureForm')) forces to stay on Capture Form with cover-type selection on browser reload (otherwise this.form resets and doesn't render correct inputs)
        if (this.newQuote && !this.isCurrentRoute(('CaptureForm'))) {
            await this.initNewQuote()
            return
        }

        // !this.isCurrentRoute(('CaptureForm') on browser reload stops resetting back to Questions flow
        if (!this.quote.id && !this.isCurrentRoute('Questions') && !this.isCurrentRoute(('CaptureForm'))) {
            await this.$router.push({name: 'Questions'})
            this.sendBingPageview()
            this.sendGaPageview()
        }


        await this.initReturningQuote()
        this.sendHotjarIdentifier(this.returningQuoteId,this.quote)
        this.$nextTick(() => {
            this.setPriceboxTerm()
        })


    },
    watch: {
        '$route.name'(name) {
            if (name !== 'CaptureForm' || name !== 'Questions') {
                document.querySelector('#tp-widget__mobile')?.classList.remove('hidden')
            }
            if(name === 'Review') {
                //document.getElementById("footer-legal-information").style.marginBottom = '6rem';
                if(window.newSplitVersion){
                    //document.querySelector('#footer-legal-information').classList.add('hidden');
                } else {
                    document.querySelector('#footer-legal-information').classList.add('mb-24'); // 6rem should only apply on Mobiles.
                    document.querySelector('#footer-legal-information').classList.add('lg:mb-0');
                }

                if (!this.returningQuote) {
                    document.querySelector('#tp-widget__mobile')?.classList.add('hidden');
                    document.querySelector('#join-nav__mobile')?.classList.add('hidden');
                }

                if(name === 'Review') {
                    digiaGtag()
                }
            }
        },
        '$route' (to, from) {
            let quote_landing_page_regex = /^\/(breakdown-cover|business-breakdown)\/your-quote\/(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=|[A-Za-z0-9+\/]{4})/gmi;
            
            // Force back to review page if user has used the back button and entered via the breakdown/business quote email landing page
            if (from.name === 'Review' 
                && this.returningQuote 
                && quote_landing_page_regex.test(window.location.pathname)) 
            {
                this.$router.push({name: 'Review'})
            }
        }
    }
});

